import { InputAdornment } from '@mui/material';
import React from 'react';
import { Icons } from '../icons/Icons';
import { useStyling } from '../Theme';

interface AIAdornmentProps {
    requiresUserCorrection?: boolean
}

export default function AIAdornment({ requiresUserCorrection = false }: AIAdornmentProps) {

    const { aiExtractedFieldColor } = useStyling();

    return (
        <InputAdornment position="start">
            <Icons.AutoAwesome sx={{ color: requiresUserCorrection ? aiExtractedFieldColor.HIGHLIGHTED : aiExtractedFieldColor.NORMAL, height: '18px', width: '18px' }} />
        </InputAdornment>
    );
};
